import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

interface AppStats {
  totalSquads: number;
  totalPredictions: number;
  totalUsers: number;
}

export function useAppStats() {
  const [stats, setStats] = useState<AppStats>({
    totalSquads: 0,
    totalPredictions: 0,
    totalUsers: 0
  });
  const [loading, setLoading] = useState(true);

  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);

      // Get total squads count
      const { count: squadsCount } = await supabase
        .from('squads')
        .select('*', { count: 'exact', head: true });

      // Get total predictions count
      const { count: predictionsCount } = await supabase
        .from('predictions')
        .select('*', { count: 'exact', head: true });

      // Get total users count
      const { count: usersCount } = await supabase
        .from('profiles')
        .select('*', { count: 'exact', head: true });

      setStats({
        totalSquads: squadsCount || 0,
        totalPredictions: predictionsCount || 0,
        totalUsers: usersCount || 0
      });
    } catch (error) {
      console.error('Failed to fetch app stats:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return { stats, loading };
}

// Helper function to format large numbers
export function formatNumber(num: number): string {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

